import { IntlFormatters, useIntl } from 'react-intl'
import {
  DenseTableRowProps,
  RowOptions,
  SelectOption
} from '../../../../../components'
import { Employment, Maybe } from '../../../../../utils/classes/graphql'
import { isAfterCurrentDate } from '../../../../../utils/dateUtils'
import { getPaymentMethodText, getEmploymentTypeText } from '../helpers'
import { EmploymentData } from '../types'

type MaybeEmployment = Maybe<Employment>

const createRowOptions = (
  formatMessage: IntlFormatters['formatMessage'],
  employment?: MaybeEmployment
): RowOptions<EmploymentData>[] => {
  const paymentOptions: SelectOption[] = [true, false].map((settlement) => {
    return {
      value: settlement.toString(),
      display: getPaymentMethodText(settlement, formatMessage)
    }
  })

  return [
    {
      key: 'tpNimi',
      options: employment?.workPlaceOptions || []
    },
    {
      key: 'taPerintaText',
      options: paymentOptions
    }
  ]
}

const createRow = (
  formatMessage: IntlFormatters['formatMessage'],
  employment?: Employment
): DenseTableRowProps<EmploymentData> => {
  return {
    alkupvm: employment?.alkupvm || null,
    loppupvm: employment?.loppupvm || null,
    paatoiminen: employment?.paatoiminen || false,
    paatoiminenText: getEmploymentTypeText(
      employment?.paatoiminen,
      formatMessage
    ),
    taPerinta: null,
    taPerintaText: '',
    taNimi: employment?.taNimi || '',
    tpNimi: employment?.tpNimi || '',
    tunniste: employment?.tunniste,
    rowOptions: createRowOptions(formatMessage, employment),
    isRowNew: employment === undefined,
    isRowEditable: employment?.loppupvm
      ? isAfterCurrentDate(employment.loppupvm)
      : true
  }
}

export const useEmploymentData = (tyosuhteet?: Employment[]) => {
  const { formatMessage } = useIntl()

  const employmentArray =
    tyosuhteet?.map((employment: Employment) =>
      createRow(formatMessage, employment)
    ) || []

  const newEmploymentRow = createRow(formatMessage)

  return { employmentArray, newEmploymentRow }
}
